import React, {useContext, useState} from 'react';

import {AuthContext} from '../../context';
import {NavbarButton, NavbarCard, NavbarHelp, NavbarList} from './';

const Navbar = ({companyName, menu}) => {
  const {dispatch, user} = useContext(AuthContext);
  const [showContact, setShowContact] = useState(false);

  const logout = () => {
    localStorage.clear();
    dispatch({type: 'LOGOUT'});
  };

  return (
    <div
      className={
        user.infos.role === 'CUSTOMER'
          ? 'navbar-container-customer'
          : 'navbar-container-admin'
      }
    >
      <NavbarCard company={companyName} onClickToLogout={logout} />
      <NavbarList menu={menu} />
      {user.infos.role === 'CUSTOMER' ? (
        <div
          className="navbar-button-help-container help"
          onMouseEnter={() => setShowContact(true)}
          onMouseLeave={() => setShowContact(false)}
        >
          <NavbarHelp showContact={showContact} />
        </div>
      ) : (
        <NavbarButton
          icon="far fa-plus-square fa-2x"
          label="Nouveau client"
          to="/admin/nouveau-client"
        />
      )}
    </div>
  );
};

export default Navbar;
